import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateAssetGroupSaga } from "src/store/asset-groups/saga";
import { AssetGroupDetailDto } from "src/store/asset-groups/type";
import * as Yup from "yup";
import { dripiconlist } from "src/helpers/iconList";
import { SectorDto } from "src/store/system/type";
import { getSectors } from "src/store/system/saga";
import { AssetTypeDto } from "src/store/asset-types/type";
import { getAssetTypeListSaga } from "src/store/asset-types/saga";

const AssetGroupEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: AssetGroupDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [assetTypes, setAssetTypes] = useState<AssetTypeDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getAssetTypeListSaga({
          payload: {
            onSuccess: (message, payload) => {
              setAssetTypes(payload);
            },
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("AssetGroup.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          Code: data.Code,
          UniversalCode: data.UniversalCode,
          MinimumAge: data.MinimumAge ?? 0,
          MaximumAge: data.MaximumAge ?? 0,
          AssetTypeId: data.AssetTypeId,
          Translates: data.Translates,
        }}
        ü
        onSubmit={(values) => {
          dispatch(
            updateAssetGroupSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Code: Yup.string().required(t("Validation.Required").toString()),
          Name: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("AssetGroup.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "AssetTypeId",
            label: t("AssetGroup.AssetType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: assetTypes,
            },
          },
          {
            field: "Code",
            label: t("AssetGroup.Code").toString(),
            col: 6,
          },
          {
            field: "Code",
            label: t("AssetGroup.UniversalCode").toString(),
            col: 6,
          },
          {
            field: "MinimumAge",
            label: t("AssetGroup.MinimumAge").toString(),
            col: 6,
            type: "number",
          },
          {
            field: "MaximumAge",
            label: t("AssetGroup.MaximumAge").toString(),
            col: 6,
            type: "number",
          },
        ]}
      />
    </React.Fragment>
  );
};
export default AssetGroupEditForm;
